export default __webpack_public_path__ + "img/erfEhSWi.59a5ef2b.svg";